import "../../assets/style/ContactUs.css"
import accept from "../../assets/icon/accept.svg"
import Topbar from "../../component/Topbar/Topbar";
import Footer from "../../component/Footer/Footer";
import { useState } from "react";

import Modal from 'react-modal';
import { useTranslation } from "react-i18next";

function ContactUs(params) {
    const { t } = useTranslation();
    const [openC, setOpenC] = useState(false)

    const [contentAlert, setContentAlert] = useState("")

    const [fullname, setFullname] = useState("")
    const [email, setEmail] = useState("")
    const [company, setCompany] = useState("")
    const [subject, setSubject] = useState("")
    const [content, setContent] = useState("")

    const sendEmail = () => {

        if(fullname === ""){
            setContentAlert(t("emptyfullname"));
            setOpenC(true)
        } else if (email === ""){
            setContentAlert(t("emptyemail"))
            setOpenC(true)
        } else if (company === ""){
            setContentAlert(t("emptycompany"))
            setOpenC(true)
        } else if (subject === ""){
            setContentAlert(t("emptysubject"))
            setOpenC(true)
        } else if (content === ""){
            setContentAlert(t("emptycontent"))
            setOpenC(true)
        } else {

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        
            const urlencoded = new URLSearchParams();
            urlencoded.append("fullName", fullname);
            urlencoded.append("company", company);
            urlencoded.append("subject", subject);
            urlencoded.append("content", content);
            urlencoded.append("email", email);
        
            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: urlencoded,
                redirect: "follow"
            };
        
            fetch(`${process.env.REACT_APP_BE}contact/email`, requestOptions)
            .then((response) => {
                if(response.ok) return response.json()
                else {
                    setContentAlert(t("errorsend"));
                    setOpenC(true)
                }
            })
            .then((result) => {
                // console.log(result);

                setOpenC(true)
    
                if(result.message === "info not completed"){
                    setContentAlert(t("errorsend"))
                } else {
                    setContentAlert(t("terimakasih"));
                    setTimeout(() => {
                        window.location.reload();
                    },2000)

                }
    
            })
            .catch((error) => {
                // console.error(error)
                setContentAlert(t("errorsend"));
                setOpenC(true)
            });
        }
    }

    return(
        <>
        <Topbar/>

        <section className='contactUs'>
            <div className='mainContactUs goneMobile'>
                <img src="/photo/Background.webp" className='backgroundMainContactUs' alt="background"/>
                <div className='contentMainContactUs'>
                    
                    <div className="listFormContactUs">
                        <div className="formContactUs">
                            <label>{t("fullname")}</label>
                            <input type="text" placeholder="John David" value={fullname} onChange={(event) => {setFullname(event.target.value)}}/>
                        </div>
                        <div className="formContactUs">
                            <label>{t("youremail")} *</label>
                            <input type="text" placeholder={t("placeholderemail")} value={email} onChange={(event) => {setEmail(event.target.value)}} />
                        </div>
                    </div>
                    <div className="listFormContactUs">
                    <div className="formContactUs">
                            <label>{t("company")} *</label>
                            <input type="text" placeholder={t("placeholdercompany")} value={company} onChange={(event) => {setCompany(event.target.value)}}/>
                        </div>
                        <div className="formContactUs">
                            <label>{t("subject")} *</label>
                            <input type="text" placeholder={t("placeholdersubject")} value={subject} onChange={(event) => {setSubject(event.target.value)}}/>
                        </div> 
                    </div>
                    <div className="formContactUs">
                        <label>{t("message")} *</label>
                        <textarea placeholder={t("placeholdermessage")} value={content} onChange={(event) => {setContent(event.target.value)}}/>
                    </div>
                    <button className="buttonBlack" onClick={() => sendEmail()}>{t("sendmessage")}</button>
                
                </div>
            </div>

            <div className="contentMainContactUsMobile">
                <p>{t("topbarfreeConsultation")}</p>

                <div className="listFormContactUs">
                    <div className="formContactUs">
                        <label>{t("fullname")}</label>
                        <input type="text" placeholder="John David" value={fullname} onChange={(event) => {setFullname(event.target.value)}}/>
                    </div>
                    <div className="formContactUs">
                        <label>{t("youremail")} *</label>
                        <input type="text" placeholder="example@mail.com" value={email} onChange={(event) => {setEmail(event.target.value)}} />
                    </div>
                </div>
                <div className="listFormContactUs">
                    <div className="formContactUs">
                        <label>{t("company")} *</label>
                        <input type="text" placeholder="your company name here" value={company} onChange={(event) => {setCompany(event.target.value)}}/>
                    </div>
                    <div className="formContactUs">
                        <label>{t("subject")} *</label>
                        <input type="text" placeholder="how can we help" value={subject} onChange={(event) => {setSubject(event.target.value)}}/>
                    </div> 
                </div>
                <div className="formContactUs">
                    <label>{t("message")} *</label>
                    <textarea placeholder="Hello there, i would like to talk about how to. . ." value={content} onChange={(event) => {setContent(event.target.value)}}/>
                </div>
                <button className="buttonBlack" onClick={() => sendEmail()}>{t("sendmessage")}</button>
                

            </div>
        </section>

        <Footer/>

        <Modal isOpen={openC} onRequestClose={() => setOpenC(!openC)} className="ModalContactUs" overlayClassName="OverlayFooter">
            <div className="notifikasiContactUs">
                <img src={accept} alt="what?"></img>
                <p className="noMargin">{contentAlert}</p>
                <button className="buttonGreenFill" onClick={() => setOpenC(!openC)}>OK</button>
            </div>
        </Modal>
        </>
    )
}

export default ContactUs;